// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm'
import store from './vuex/store'
import _ from 'lodash'
import VeeValidate from 'vee-validate'
import Datetime from 'vue-datetime'
import bugsnag from './bugsnag'
import bugsnagVue from 'bugsnag-vue'

// Polyfill
import 'babel-polyfill'

// Load bootstrap themes
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Load Bugsnag
bugsnag.use(bugsnagVue(bugsnag))

// Disable production tip
Vue.config.productionTip = false

// Use VueResource
Vue.use(VueResource)
Vue.use(BootstrapVue)
Vue.use(VeeValidate)
Vue.use(Datetime)

// Set the base address
Vue.http.options.root = SERVICE_URL

// Subscribe to state changes
store.subscribe((mutation, state) => {
    // Fetch the members for all groups
    if (mutation.type === 'INSERT_GROUP_LIST') {
        _.each(mutation.payload, (group, index) => {
            store.dispatch('group_members', {group, index})
        })
    }
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    template: '<App/>',
    components: {
        App
    }
})



// WEBPACK FOOTER //
// ./src/main.js